import React, { useEffect, useState, useContext } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import { AuthContext } from "../../utility/services/AuthContext";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";
const HelpAndSupport = () => {
  const pageTitle = "Help & Support";

  const [htmlContent, setHtmlContent] = useState("");

  const { setLoading, user } = useContext(AuthContext);
  const { consoleService } = Functions();
  const { get_specific_pages_details } = ApiService();

  useEffect(() => {
    trackScreenView("help_and_support_screen", { screen_name: "Help & Support", ...getUserTrackingParams(user) });
    get_initial_details();
  }, []);

  async function get_initial_details() {
    try {
      setLoading(true);
      const res = await get_specific_pages_details(pageTitle);
      if (res.status === 1) {
        setHtmlContent(res.data.des);
        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }
  return (
    <>
      <section className="py-5 termscontent">
        <div className="container">
          <div className="row">
            <div className="col-md-12 termHead">
              <h1>Help And Support</h1>
            </div>
            <div
              className="col-md-12"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            ></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HelpAndSupport;
